import _get from 'lodash/get';
import * as immutable from 'object-path-immutable';
import * as types from './actionTypes';

const initialState = {
  list: {
    data: [],
    isLoading: false,
    isLoaded: false,
    error: '',
  },
  unconditionalList: {
    isLoading: false,
    isLoaded: false,
    data: {},
    error: '',
  },
  gifts: [],
  data: {},
  isApplying: false,
  isApplied: false,
  isReapplied: false,
  isAllRewardsInStoplist: false,
  isAllConditionGoodsInStopList: false,
  isClearing: false,
  error: '',
  isLoadingStockApply: false,
};

export default function stockReducer(state = initialState, action) {
  switch (action.type) {
    case types.IS_LOADING_STOCK_APPLY:
      return {
        ...state,
        isLoadingStockApply: action.payload,
      };
    case types.FETCH_LIST_REQUEST:
      return immutable.assign(state, 'list', {
        isLoading: true,
        isLoaded: false,
        error: '',
      });

    case types.FETCH_LIST_SUCCESS:
      return immutable.assign(state, 'list', {
        data: action.payload,
        isLoading: false,
        isLoaded: true,
      });

    case types.FETCH_LIST_FAILURE:
      return immutable.assign(state, 'list', {
        data: [],
        isLoading: true,
        isLoaded: false,
        error: action.payload,
      });

    //

    case types.APPLY_STOCK_REQUEST:
      return {
        ...state,
        isApplying: true,
        // isApplied: false,
        error: '',
      };

    case types.APPLY_STOCK_SUCCESS:
      return {
        ...state,
        isApplying: false,
        isApplied: true,
        data: action.payload,
        error: '',
        gifts: _get(action.payload, 'details.selected', []),
      };

    case types.APPLY_STOCK_FAILURE:
      return {
        ...state,
        data: {},
        isApplying: false,
        isApplied: false,
        error: action.payload,
      };

    //

    case types.APPLY_STOCK_EXTRA_REQUEST:
      return {
        ...state,
        error: '',
      };

    case types.APPLY_STOCK_EXTRA_SUCCESS:
      return {
        ...state,
        error: '',
      };

    case types.APPLY_STOCK_EXTRA_FAILURE:
      return {
        ...state,
        error: action.payload,
      };

    //

    case types.CLEAR_STOCK_REQUEST:
      return {
        ...state,
        isClearing: true,
        error: '',
      };

    case types.CLEAR_STOCK_SUCCESS:
      return {
        ...state,
        gifts: [],
        data: {},
        isApplying: false,
        isApplied: false,
        isClearing: false,
        isAllConditionGoodsInStopList: false,
        isAllRewardsInStoplist: false,
        error: '',
      };

    case types.CLEAR_STOCK_FAILURE:
      return {
        ...state,
        isClearing: false,
        error: action.payload,
      };

    case types.GET_UNCONDITIONAL_LIST_REQUEST:
      return {
        ...state,
        unconditionalList: {
          ...state.unconditionalList,
          isLoading: true,
          isLoaded: false,
          error: '',
        },
      };

    case types.GET_UNCONDITIONAL_LIST_SUCCESS:
      return {
        ...state,
        unconditionalList: {
          ...state.unconditionalList,
          data: action.payload,
          isLoading: false,
          isLoaded: true,
          error: '',
        },
      };

    case types.GET_UNCONDITIONAL_LIST_FAILURE:
      return {
        ...state,
        unconditionalList: {
          ...state.unconditionalList,
          data: {},
          isLoading: false,
          isLoaded: false,
          error: action.error,
        },
      };

    case types.ADD_TO_CART_REQUEST: {
      const goods = _get(state, `data.details.conditions[${action.payload.condIdx}].goods`, []);
      const indexOfGoodToUpdate = goods.findIndex(good => good.id === action.payload.goodId);

      return immutable.assign(
        state,
        ['data', 'details', 'conditions', action.payload.condIdx, 'goods', indexOfGoodToUpdate],
        {
          isAdding: true,
          isAdded: false,
          error: '',
        },
      );
    }

    case types.ADD_TO_CART_SUCCESS: {
      const goods = _get(state, `data.details.conditions[${action.payload.condIdx}].goods`, []);
      const indexOfGoodToUpdate = goods.findIndex(good => good.id === action.payload.goodId);

      return immutable.assign(
        state,
        ['data', 'details', 'conditions', action.payload.condIdx, 'goods', indexOfGoodToUpdate],
        {
          isAdding: false,
          isAdded: true,
        },
      );
    }

    case types.ADD_TO_CART_FAILURE: {
      const goods = _get(state, `data.details.conditions[${action.payload.condIdx}].goods`, []);
      const indexOfGoodToUpdate = goods.findIndex(good => good.id === action.payload.goodId);

      return immutable.assign(
        state,
        ['data', 'details', 'conditions', action.payload.condIdx, 'goods', indexOfGoodToUpdate],
        {
          isAdding: false,
          isAdded: false,
          error: action.payload.error,
        },
      );
    }

    case types.REMOVE_INGREDIENT: {
      const goods = _get(
        state,
        `data.details.${action.payload.stockRole}[${action.payload.index}].goods`,
        [],
      );

      const indexOfGoodToUpdate = goods.findIndex(good => good.id === action.payload.goodId);
      const indexOfVariationToUpdate = goods[indexOfGoodToUpdate].variations.findIndex(
        variation => variation.id === action.payload.variationId,
      );

      return immutable.update(
        state,
        [
          'data',
          'details',
          action.payload.stockRole,
          action.payload.index,
          'goods',
          indexOfGoodToUpdate,
          'variations',
          indexOfVariationToUpdate,
          'include_ingredients',
        ],
        ingredients => {
          const indexOfIngredientToUpdate = ingredients.findIndex(
            ingredient => ingredient.id === action.payload.ingredientId,
          );
          return immutable.update(ingredients, [indexOfIngredientToUpdate], ingredient =>
            immutable.set(ingredient, 'removed', !ingredient.removed),
          );
        },
      );
    }

    case types.CANCEL_REMOVED_INGREDIENTS: {
      const goods = _get(
        state,
        `data.details.${action.payload.stockRole}[${action.payload.index}].goods`,
        [],
      );
      const indexOfGoodToUpdate = goods.findIndex(good => good.id === action.payload.goodId);
      const indexOfVariationToUpdate = goods[indexOfGoodToUpdate].variations.findIndex(
        variation => variation.id === action.payload.variationId,
      );

      return immutable.update(
        state,
        [
          'data',
          'details',
          action.payload.stockRole,
          action.payload.index,
          'goods',
          indexOfGoodToUpdate,
          'variations',
          indexOfVariationToUpdate,
          'include_ingredients',
        ],
        ingredients =>
          (ingredients || []).map(ingredient => immutable.set(ingredient, 'removed', false)),
      );
    }

    case types.ADD_REWARD_REQUEST: {
      const goods = _get(state, `data.details.rewards[${action.payload.rewardIdx}].goods`, []);
      const indexOfGoodToUpdate = goods.findIndex(good => good.id === action.payload.goodId);

      return immutable.assign(
        state,
        ['data', 'details', 'rewards', action.payload.rewardIdx, 'goods', indexOfGoodToUpdate],
        {
          isAdding: true,
          isAdded: false,
          error: '',
        },
      );
    }

    case types.ADD_REWARD_SUCCESS: {
      const goods = _get(state, `data.details.rewards[${action.payload.rewardIdx}].goods`, []);
      const indexOfGoodToUpdate = goods.findIndex(good => good.id === action.payload.goodId);

      return immutable.assign(
        state,
        ['data', 'details', 'rewards', action.payload.rewardIdx, 'goods', indexOfGoodToUpdate],
        {
          isAdding: false,
          isAdded: true,
        },
      );
    }

    case types.ADD_REWARD_FAILURE: {
      const goods = _get(state, `data.details.rewards[${action.payload.rewardIdx}].goods`, []);
      const indexOfGoodToUpdate = goods.findIndex(good => good.id === action.payload.goodId);

      return immutable.assign(
        state,
        ['data', 'details', 'rewards', action.payload.rewardIdx, 'goods', indexOfGoodToUpdate],
        {
          isAdding: false,
          isAdded: false,
          error: action.payload.error,
        },
      );
    }

    case types.CLEAR_STOCK_ERRORS_SUCCESS:
      return {
        ...state,
        error: '',
      };

    case types.APPLY_STOCK_GIFTS: {
      return {
        ...state,
        gifts: action.payload,
      };
    }

    case types.SET_STOCK_IS_REAPPLIED: {
      return {
        ...state,
        isReapplied: action.payload,
      };
    }

    case types.SET_ALL_REWARDS_IN_STOPLIST:
      return {
        ...state,
        isAllRewardsInStoplist: action.payload,
      };

    case types.SET_ALL_CONDITION_GOODS_IN_STOPLIST:
      return {
        ...state,
        isAllConditionGoodsInStopList: action.payload,
      };

    default:
      return state;
  }
}
